import React, { useEffect, useState } from "react";
import { X, Megaphone } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BG = { info: "bg-b2b", success: "bg-green-600", warning: "bg-brand" };

export default function AnnouncementBar() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [hidden, setHidden] = useState(() => JSON.parse(sessionStorage.getItem("kz_ann_hidden") || "[]"));

  useEffect(() => { api.get("/announcements").then(r => setItems(r.data)).catch(() => {}); }, [user]);
  const visible = items.filter(a => !hidden.includes(a.id));
  useEffect(() => {
    if (visible.length < 2) return;
    const t = setInterval(() => setIdx(i => (i + 1) % visible.length), 6000);
    return () => clearInterval(t);
  }, [visible.length]);

  if (visible.length === 0) return null;
  const a = visible[idx % visible.length];
  const close = () => { const h = [...hidden, a.id]; setHidden(h); sessionStorage.setItem("kz_ann_hidden", JSON.stringify(h)); };

  return (
    <div data-testid="announcement-bar" className={`${BG[a.level] || BG.info} text-white text-sm`}>
      <div className="kz-container flex items-center gap-3 py-2">
        <Megaphone size={14} className="shrink-0"/>
        <div key={a.id} className="flex-1 min-w-0 truncate animate-in fade-in slide-in-from-bottom-1 duration-300">
          <b className="mr-2">{a.title}</b><span className="opacity-90">{a.message}</span>
        </div>
        {visible.length > 1 && <span className="text-[11px] opacity-75 font-mono">{(idx % visible.length) + 1}/{visible.length}</span>}
        <button data-testid="announcement-close" onClick={close} aria-label="Kapat" className="opacity-80 hover:opacity-100"><X size={16}/></button>
      </div>
    </div>
  );
}
